<template>
	<page>
		<module>
			<refund-list v-if="auth('b_refund_info_detail')" :state="state"></refund-list>
			<return-list v-if="auth('b_return_info_detail')" :return_state="return_state"></return-list>
		</module>
	</page>
</template>

<script>
	import refundList from './refund_list.vue'
	import returnList from './return_list.vue'
	
	export default {
		components: {
			refundList,
			returnList
		},
		
		props: {
			tab: String,
			state: String,
			return_state: String
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .order {
		box-sizing: border-box;
		min-width: 1000px;
		border: 1px solid #eee;
		margin: 16px 0;
		
		&-head {
			height: 34px;
			border-bottom: 1px solid #eee;
			padding: 0 8px;
			font-size: 12px;
			background: #F8F8F8;
			
			.number {
				margin-left: 15px;
				color: #333;
			}
			
			.info {
				border-left: 1px solid #999;
				padding-left: 8px;
				margin-left: 15px;
				color: #999;
			}
		}
		
		&-product {
			flex-grow: 400;
			flex-basis: 400px;
			
			.sku {
				box-sizing: border-box;
				padding: 10px 0 10px 14px;
				
				&:nth-child(n+2) {
					border-top: 1px solid #eee;
				}
				
				&-image {
					width: 80px;
					height: 80px;
					margin-right: 24px;
				}
				
				&-name {
					font-size: 12px;
					color: #666;
				}
				
				&-spec {
					margin-top: 10px;
					font-size: 12px;
				}
			}
		}
		
		&-state,
		&-handle {
			flex-grow: 170;
			flex-basis: 170px;
			box-sizing: border-box;
			border-left: 1px solid #eee;
		}
		
		&-sum {
			flex-grow: 130;
			flex-basis: 130px;
			border-left: 1px solid #eee;
			line-height: 20px;
			font-size: 12px;
			text-align: center;
			color: #333;
			
			span {
				color: #888;
			}
		}
		
		&-state {
			line-height: 20px;
			font-size: 12px;
			
			a {
				color: #0060EF;
			}
		}
		
		&-handle {
			.c-button:nth-child(n+2) {
				margin-top: 8px;
			}
		}
	}
</style>
